import React from 'react'

import { Element, Text } from "components/shared/base"
import TwoColumnItem from "./TwoColumnItem"
import {
  PrismicHomepageDataBodyTwoColumnItem,
  PrismicHomepageDataBodyTwoColumnPrimary
} from "types/__generated__/gatsby-graphql"
import { mapColumnSize } from "utils"

interface OwnProps {
  items: PrismicHomepageDataBodyTwoColumnItem[]
}

export type TwoColumnProps = OwnProps & PrismicHomepageDataBodyTwoColumnPrimary

const TwoColumn: React.FC<TwoColumnProps> = ({
  items,
  border_above_items,
  center_column_content,
  headline,
  title_width
}): React.ReactElement => {

  const headlineText = headline?.text || "";
  const titleColumnSize = mapColumnSize(title_width);

  return (
    <Element
      as="section"
      px="20px"
      py={["0", "70px"]}
    >
      <Element m="0 auto" maxWidth="contentWidth">
        {headlineText && (
          <Element display="grid" gridTemplateColumns="repeat(12, 1fr)">
            <Text
              as="h2"
              fontSize={["text.titleMobile", "text.title"]}
              fontWeight="700"
              gridColumnEnd={["12", titleColumnSize.gridColumnEnd ]}
              gridColumnStart={["1", titleColumnSize.gridColumnStart ]}
              lineHeight="primary"
              m={["0 auto", "0 auto 30px"]}
              textAlign={["left", "center"]}
            >
              {headlineText}
            </Text>
          </Element>
        )}
        <Element
          borderColor="textPrimary"
          borderTop={border_above_items ? "1px solid" : ""}
          display="grid"
          gridColumnGap="25px"
          gridTemplateColumns="repeat(12, 1fr)"
          textAlign={center_column_content ? "center" : "left"}
        >
          {items?.map((item, index) => (
            <TwoColumnItem
              key={index}
              index={index}
              item={item}
              {...item}
            />
          ))}
        </Element>
      </Element>
    </Element>
  )
}

export default TwoColumn
